"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cardDetailApi = require("@/api/cardDetailApi");
var projectApi = _interopRequireWildcard(require("@/api/projectManageApi"));
var _utils = require("@/utils");
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TransactionDetail',
  components: {
    CountTo: _vueCountTo.default
  },
  data: function data() {
    return {
      loading: false,
      list: [],
      total: 0,
      dateRange: [],
      listParams: {
        page: 1,
        limit: 20,
        orderNo: '',
        empIntegralId: '',
        projectId: '',
        appId: '',
        customerId: '',
        type: '',
        startTime: '',
        endTime: ''
      },
      // 项目选项
      projectOptions: [],
      projectsPage: 1,
      projectsLimit: 20,
      projectsTotal: 0,
      projectsLoading: false,
      projectsLoadingMore: false,
      projectsNoMore: false,
      projectParams: {
        page: 1,
        limit: 20,
        projectName: ''
      },
      // 客户选项
      customerOptions: [],
      customersPage: 1,
      customersLimit: 20,
      customersTotal: 0,
      customersLoading: false,
      customersLoadingMore: false,
      customersNoMore: false,
      customerParams: {
        page: 1,
        limit: 20,
        keyword: ''
      },
      // 小程序选项
      appOptions: [],
      miniappsPage: 1,
      miniappsLimit: 20,
      miniappsTotal: 0,
      miniappsLoading: false,
      miniappsLoadingMore: false,
      miniappsNoMore: false,
      miniappsKeyword: '',
      // 交易类型选项
      typeOptions: [],
      // 统计数据
      stats: {
        total: 0,
        incr: 0,
        used: 0
      },
      isFilterCollapsed: true
    };
  },
  watch: {
    dateRange: function dateRange(val) {
      if (val) {
        this.listParams.startTime = val[0];
        this.listParams.endTime = val[1];
      } else {
        this.listParams.startTime = '';
        this.listParams.endTime = '';
      }
    }
  },
  created: function created() {
    this.getList();

    // 从URL参数中获取项目ID
    var projectId = this.$route.query.projectId;
    if (projectId) {
      this.listParams.projectId = projectId;
    }
  },
  methods: {
    fetchOptions: function () {
      var _fetchOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              try {
                // 获取项目列表选项
                this.fetchInitialProjects();

                // 获取小程序选项
                this.fetchInitialMiniapps();

                // 获取客户选项
                this.fetchInitialCustomers();
              } catch (error) {
                this.$message.error('获取选项数据失败');
              }
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function fetchOptions() {
        return _fetchOptions.apply(this, arguments);
      }
      return fetchOptions;
    }(),
    // 项目选项方法
    fetchInitialProjects: function () {
      var _fetchInitialProjects = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var params, res, projectList, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.projectsLoading = true;
              _context2.p = 1;
              params = {
                page: this.projectParams.page,
                limit: this.projectParams.limit,
                projectName: this.projectParams.projectName
              };
              _context2.n = 2;
              return projectApi.getFudouProjectList(params);
            case 2:
              res = _context2.v;
              if (res && res.page && Array.isArray(res.page.list)) {
                projectList = res.page.list;
                this.projectOptions = projectList.map(function (item) {
                  return {
                    value: item.id,
                    label: "".concat(item.projectName, " (ID:").concat(item.id, ")")
                  };
                });
                this.projectsTotal = res.page.total || 0;
                this.projectsNoMore = projectList.length < this.projectParams.limit;
              } else {
                this.projectsNoMore = true;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              this.$message.error('获取项目选项失败');
            case 4:
              _context2.p = 4;
              this.projectsLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function fetchInitialProjects() {
        return _fetchInitialProjects.apply(this, arguments);
      }
      return fetchInitialProjects;
    }(),
    searchProjects: function () {
      var _searchProjects = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(query) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.projectParams.page = 1;
              this.projectsNoMore = false;
              this.projectParams.projectName = query;
              this.fetchInitialProjects();
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function searchProjects(_x) {
        return _searchProjects.apply(this, arguments);
      }
      return searchProjects;
    }(),
    loadMoreProjects: function () {
      var _loadMoreProjects = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var params, res, projectList, newOptions, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!(this.projectsLoadingMore || this.projectsNoMore)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.projectsLoadingMore = true;
              this.projectParams.page++;
              _context4.p = 2;
              params = {
                page: this.projectParams.page,
                limit: this.projectParams.limit,
                projectName: this.projectParams.projectName
              };
              _context4.n = 3;
              return projectApi.getFudouProjectList(params);
            case 3:
              res = _context4.v;
              if (res && res.page && Array.isArray(res.page.list)) {
                projectList = res.page.list;
                if (projectList.length > 0) {
                  newOptions = projectList.map(function (item) {
                    return {
                      value: item.id,
                      label: "".concat(item.projectName, " (ID:").concat(item.id, ")")
                    };
                  });
                  this.projectOptions = [].concat(_toConsumableArray(this.projectOptions), _toConsumableArray(newOptions));
                  this.projectsNoMore = projectList.length < this.projectParams.limit;
                } else {
                  this.projectsNoMore = true;
                }
              } else {
                this.projectsNoMore = true;
              }
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t2 = _context4.v;
              this.$message.error('加载更多项目失败');
            case 5:
              _context4.p = 5;
              this.projectsLoadingMore = false;
              return _context4.f(5);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 4, 5, 6]]);
      }));
      function loadMoreProjects() {
        return _loadMoreProjects.apply(this, arguments);
      }
      return loadMoreProjects;
    }(),
    // 客户选项方法
    fetchInitialCustomers: function () {
      var _fetchInitialCustomers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res, customerList, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              this.customersLoading = true;
              _context5.p = 1;
              _context5.n = 2;
              return projectApi.getCustomerList(this.customerParams);
            case 2:
              res = _context5.v;
              if (res) {
                customerList = Array.isArray(res) ? res : [];
                this.customerOptions = customerList.map(function (item) {
                  return {
                    value: item.id,
                    label: item.name || item.customerName
                  };
                });
                this.customersNoMore = customerList.length < this.customerParams.limit;
              } else {
                this.customersNoMore = true;
              }
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t3 = _context5.v;
              this.$message.error('获取客户选项失败');
            case 4:
              _context5.p = 4;
              this.customersLoading = false;
              return _context5.f(4);
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3, 4, 5]]);
      }));
      function fetchInitialCustomers() {
        return _fetchInitialCustomers.apply(this, arguments);
      }
      return fetchInitialCustomers;
    }(),
    searchCustomers: function () {
      var _searchCustomers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(query) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this.customerParams.page = 1;
              this.customersNoMore = false;
              this.customerParams.keyword = query;
              this.fetchInitialCustomers();
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function searchCustomers(_x2) {
        return _searchCustomers.apply(this, arguments);
      }
      return searchCustomers;
    }(),
    loadMoreCustomers: function () {
      var _loadMoreCustomers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res, customerList, newOptions, _t4;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              if (!(this.customersLoadingMore || this.customersNoMore)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              this.customersLoadingMore = true;
              this.customerParams.page += 1;
              _context7.p = 2;
              _context7.n = 3;
              return projectApi.getCustomerList(this.customerParams);
            case 3:
              res = _context7.v;
              if (res) {
                customerList = Array.isArray(res) ? res : [];
                if (customerList.length > 0) {
                  newOptions = customerList.map(function (item) {
                    return {
                      value: item.id,
                      label: item.name || item.customerName
                    };
                  });
                  this.customerOptions = [].concat(_toConsumableArray(this.customerOptions), _toConsumableArray(newOptions));
                  this.customersNoMore = customerList.length < this.customerParams.limit;
                } else {
                  this.customersNoMore = true;
                }
              } else {
                this.customersNoMore = true;
              }
              _context7.n = 5;
              break;
            case 4:
              _context7.p = 4;
              _t4 = _context7.v;
              this.$message.error('加载更多客户失败');
            case 5:
              _context7.p = 5;
              this.customersLoadingMore = false;
              return _context7.f(5);
            case 6:
              return _context7.a(2);
          }
        }, _callee7, this, [[2, 4, 5, 6]]);
      }));
      function loadMoreCustomers() {
        return _loadMoreCustomers.apply(this, arguments);
      }
      return loadMoreCustomers;
    }(),
    // 小程序选项方法
    fetchInitialMiniapps: function () {
      var _fetchInitialMiniapps = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var res, _t5;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              this.miniappsLoading = true;
              _context8.p = 1;
              _context8.n = 2;
              return (0, _cardDetailApi.getMiniappList)();
            case 2:
              res = _context8.v;
              if (res && Array.isArray(res)) {
                this.appOptions = res.map(function (item) {
                  return {
                    value: item.id,
                    label: item.appName
                  };
                });
                this.miniappsTotal = res.length || 0;
                this.miniappsNoMore = true; // 小程序列表一般较少，一次加载完毕即可
              } else {
                this.miniappsNoMore = true;
              }
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t5 = _context8.v;
              this.$message.error('获取小程序选项失败');
            case 4:
              _context8.p = 4;
              this.miniappsLoading = false;
              return _context8.f(4);
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 3, 4, 5]]);
      }));
      function fetchInitialMiniapps() {
        return _fetchInitialMiniapps.apply(this, arguments);
      }
      return fetchInitialMiniapps;
    }(),
    searchMiniapps: function () {
      var _searchMiniapps = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(query) {
        var res, _t6;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              this.miniappsLoading = true;
              this.miniappsKeyword = query;
              _context9.p = 1;
              _context9.n = 2;
              return (0, _cardDetailApi.getMiniappList)({
                keyword: query
              });
            case 2:
              res = _context9.v;
              if (res && Array.isArray(res)) {
                this.appOptions = res.map(function (item) {
                  return {
                    value: item.id,
                    label: item.appName
                  };
                });
              }
              _context9.n = 4;
              break;
            case 3:
              _context9.p = 3;
              _t6 = _context9.v;
              this.$message.error('搜索小程序失败');
            case 4:
              _context9.p = 4;
              this.miniappsLoading = false;
              return _context9.f(4);
            case 5:
              return _context9.a(2);
          }
        }, _callee9, this, [[1, 3, 4, 5]]);
      }));
      function searchMiniapps(_x3) {
        return _searchMiniapps.apply(this, arguments);
      }
      return searchMiniapps;
    }(),
    loadMoreMiniapps: function () {
      var _loadMoreMiniapps = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              // 小程序列表一般较少，一次加载完毕即可
              this.miniappsNoMore = true;
            case 1:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function loadMoreMiniapps() {
        return _loadMoreMiniapps.apply(this, arguments);
      }
      return loadMoreMiniapps;
    }(),
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var params, res, _t7;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              this.loading = true;
              _context1.p = 1;
              params = {
                page: this.listParams.page,
                limit: this.listParams.limit,
                orderNo: this.listParams.orderNo || undefined,
                empIntegralId: this.listParams.empIntegralId || undefined,
                projectId: this.listParams.projectId || undefined,
                appId: this.listParams.appId || undefined,
                customerId: this.listParams.customerId || undefined,
                type: this.listParams.type || undefined,
                startTime: this.listParams.startTime || undefined,
                endTime: this.listParams.endTime || undefined
              };
              _context1.n = 2;
              return (0, _cardDetailApi.getCardTransactions)(params);
            case 2:
              res = _context1.v;
              if (res && res.page) {
                this.list = res.page.list || [];
                this.total = res.page.total || 0;

                // 使用API返回的统计数据
                if (res.statistics) {
                  this.stats = {
                    total: res.page.total || 0,
                    incr: res.statistics.incr || 0,
                    used: res.statistics.used || 0
                  };
                } else {
                  this.stats = {
                    total: res.page.total || 0,
                    incr: 0,
                    used: 0
                  };
                }

                // 设置交易类型选项
                if (res.typeSelect && Array.isArray(res.typeSelect)) {
                  this.typeOptions = res.typeSelect.map(function (item) {
                    return {
                      value: item.key,
                      label: item.value
                    };
                  });
                }
              } else {
                this.list = [];
                this.total = 0;
                this.stats = {
                  total: 0,
                  incr: 0,
                  used: 0
                };
              }
              _context1.n = 4;
              break;
            case 3:
              _context1.p = 3;
              _t7 = _context1.v;
              this.$message.error('获取交易明细失败');
              this.list = [];
              this.total = 0;
              this.stats = {
                total: 0,
                incr: 0,
                used: 0
              };
            case 4:
              _context1.p = 4;
              this.loading = false;
              return _context1.f(4);
            case 5:
              return _context1.a(2);
          }
        }, _callee1, this, [[1, 3, 4, 5]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    resetForm: function resetForm() {
      this.$refs.searchForm.resetFields();
      this.dateRange = [];
      this.listParams = {
        page: 1,
        limit: 20,
        orderNo: '',
        empIntegralId: '',
        projectId: '',
        appId: '',
        customerId: '',
        type: '',
        startTime: '',
        endTime: ''
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listParams.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listParams.page = val;
      this.getList();
    },
    exportData: function () {
      var _exportData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var params, res, blob, urlFileName, blobUrl, link, _t8, _t9;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              _context10.p = 0;
              this.loading = true;
              params = {
                orderNo: this.listParams.orderNo || undefined,
                empIntegralId: this.listParams.empIntegralId || undefined,
                projectId: this.listParams.projectId || undefined,
                appId: this.listParams.appId || undefined,
                customerId: this.listParams.customerId || undefined,
                type: this.listParams.type || undefined,
                startTime: this.listParams.startTime || undefined,
                endTime: this.listParams.endTime || undefined
              };
              _context10.n = 1;
              return (0, _cardDetailApi.exportTransactionDetail)(params);
            case 1:
              res = _context10.v;
              if (!(res && res.fileName)) {
                _context10.n = 6;
                break;
              }
              _context10.p = 2;
              _context10.n = 3;
              return (0, _cardDetailApi.downloadExportFile)(res.fileName);
            case 3:
              blob = _context10.v;
              urlFileName = res.fileName.split('/').pop() || 'export.xlsx';
              blobUrl = window.URL.createObjectURL(blob);
              link = document.createElement('a');
              link.style.display = 'none';
              link.href = blobUrl;
              link.download = urlFileName;
              document.body.appendChild(link);
              link.click();
              setTimeout(function () {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
              }, 100);
              this.$message.success('导出成功');
              // }
              _context10.n = 5;
              break;
            case 4:
              _context10.p = 4;
              _t8 = _context10.v;
              this.$message.error('下载文件失败: ' + (_t8.message || _t8));
            case 5:
              _context10.n = 7;
              break;
            case 6:
              this.$message.error('导出失败：未获取到文件链接');
            case 7:
              _context10.n = 9;
              break;
            case 8:
              _context10.p = 8;
              _t9 = _context10.v;
              this.$message.error('导出失败');
            case 9:
              _context10.p = 9;
              this.loading = false;
              return _context10.f(9);
            case 10:
              return _context10.a(2);
          }
        }, _callee10, this, [[2, 4], [0, 8, 9, 10]]);
      }));
      function exportData() {
        return _exportData.apply(this, arguments);
      }
      return exportData;
    }(),
    formatMoney: function formatMoney(value) {
      if (!value) return '0.00';
      return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    formatDateTime: function formatDateTime(dateTime) {
      if (!dateTime) return '-';

      // 如果是Date对象，格式化为字符串
      if (dateTime instanceof Date) {
        var year = dateTime.getFullYear();
        var month = String(dateTime.getMonth() + 1).padStart(2, '0');
        var day = String(dateTime.getDate()).padStart(2, '0');
        var hours = String(dateTime.getHours()).padStart(2, '0');
        var minutes = String(dateTime.getMinutes()).padStart(2, '0');
        var seconds = String(dateTime.getSeconds()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      }

      // 如果已经是格式化的字符串，直接返回
      return dateTime;
    },
    getTypeTag: function getTypeTag(type) {
      var typeMap = {
        1: 'success',
        // 发放
        2: 'danger',
        // 回收
        3: 'warning',
        // 使用
        4: 'info',
        // 过期
        5: 'primary' // 退回
      };
      return typeMap[type] || 'info';
    },
    getTypeIcon: function getTypeIcon(type) {
      var iconMap = {
        1: 'el-icon-plus',
        // 发放
        2: 'el-icon-minus',
        // 回收
        3: 'el-icon-shopping-cart-full',
        // 使用 - improved icon
        4: 'el-icon-time',
        // 过期
        5: 'el-icon-refresh' // 退回
      };
      return iconMap[type] || 'el-icon-document';
    },
    // 处理键盘快捷键
    handleKeyDown: function handleKeyDown(e) {
      // 如果在输入框中或有弹窗打开时，不处理快捷键
      if (document.querySelector('.el-dialog__wrapper') || document.querySelector('.el-drawer__open') || document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        return;
      }

      // 处理不同的键盘组合
      if (e.ctrlKey && e.key === 'f') {
        // 阻止浏览器默认的查找功能
        e.preventDefault();
        // 聚焦第一个输入框
        var firstInput = document.querySelector('.app-container input');
        if (firstInput) firstInput.focus();
      } else if (e.ctrlKey && e.key === 'r') {
        // 阻止浏览器刷新
        e.preventDefault();
        // 刷新数据
        this.getList();
      } else if (e.key === 'Escape') {
        // 重置筛选
        this.resetForm();
      }
    },
    loadTypeOptions: function loadTypeOptions() {
      var _this = this;
      if (this.typeOptions && this.typeOptions.length > 0) {
        return; // 如果已经加载过，就不重复加载
      }
      this.loading = true;
      // 交易类型通常是在获取交易列表数据时一起返回的
      var params = {
        page: 1,
        limit: 1
      };
      (0, _cardDetailApi.getCardTransactions)(params).then(function (res) {
        if (res && res.typeSelect && Array.isArray(res.typeSelect)) {
          _this.typeOptions = res.typeSelect.map(function (item) {
            return {
              value: item.key,
              label: item.value
            };
          });
        }
        _this.loading = false;
      }).catch(function (err) {
        _this.$message.error('获取交易类型失败');
        _this.loading = false;
      });
    }
  }
};